/* eslint-disable react/prop-types */

import { motion } from "framer-motion";
import { useRef, useState } from "react";

import { Link } from "react-router-dom";

const ResearchHome = ({ schools }) => {
  const [selectedHover, setSelectedHover] = useState(0);

  return (
    <motion.div
      id="service"
      // initial={{ opacity: 0, y: 200 }}
      // transition={{ duration: 0.75 }}
      // whileInView={{ opacity: 1, y: 0 }}
      className=""
    >
      {/* Desktop Section */}
      <div className="hidden w-full gap-1 mt-8 lg:flex">
        {schools.map((info, idx) => (
          <motion.div
            key={idx}
            className={`relative w-1/4 overflow-hidden ${
              selectedHover === info.id ? "w-1/4" : ""
            }`}
            initial={{ width: "25%" }}
            onHoverStart={() => setSelectedHover(info.id)}
            onHoverEnd={() => setSelectedHover(0)}
            whileHover={{ width: "50%" }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            <ComprehensiveMaritimeCard info={info} />
          </motion.div>
        ))}
      </div>

      {/* Mobile Section */}
      <div className="grid grid-cols-1 gap-1 sm:grid-cols-2 md:grid-cols-2 lg:hidden">
        {schools.map((info, index) => (
          <ComprehensiveMaritimeCard key={index} info={info} isMobile />
        ))}
      </div>
    </motion.div>
  );
};

export default ResearchHome;

const ComprehensiveMaritimeCard = ({ info, isMobile }) => {
  const container = useRef(null);

  return (
    <motion.div
      ref={container}
      className="h-96 md:h-[500px] relative group/card"
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, amount: 0.2 }}
      whileTap={{ scale: isMobile ? 1.05 : 1 }} // Adds tap animation for mobile
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      {/* Background Image */}
      <div className="absolute top-0 bottom-0 left-0 right-0 z-10 h-full overflow-hidden">
        <img
          src={info.image_url}
          alt="ComprehensiveMaritime"
          className="object-cover w-full h-full"
        />
        <div className="absolute inset-0 top-0 left-0 w-full bg-black/30 "></div>
      </div>

      {/* Content */}
      <div className="absolute left-0 right-0 z-20 text-white bottom-10">
        <h1 className="text-xl font-bold text-center font-domine md:text-2xl lg:text-3xl">
          <Link to={`/academics/${info?.slug}`}>{info.name}</Link>
        </h1>

        <p className="px-5 mt-5 text-center">{info.description}</p>
      </div>
    </motion.div>
  );
};
